import * as Yup from 'yup';
import { verifyIpAddressNotation } from './PolicyUtil';

export const usePolicyModalHandlers = (
  existingPolicies,
  currentPolicy,
  onHide,
) => {
  const otherPolicies =
    existingPolicies !== undefined
      ? existingPolicies.filter((policy) =>
          currentPolicy ? policy.name !== currentPolicy.name : true,
        )
      : [];

  const ipAddrValidation = Yup.string()
    .test(
      'valid ip address notation',
      'Invalid IP Address / Range notation',
      (value) => (value ? verifyIpAddressNotation(value) : true),
    )
    .test('unique ip addr / range', 'IP notation already in use', (value) => {
      const dupPolicies = otherPolicies.filter(
        (policy) => policy.ipAddressOrRangeNotation === value,
      );
      return dupPolicies.length === 0;
    })
    .required('Required');

  const yupSchema = Yup.object().shape({
    policyName: Yup.string()
      .test('uniqueName', 'Policy name already in use', (value) => {
        const dupPolicies = otherPolicies.filter(
          (policy) => policy.name === value,
        );
        return dupPolicies.length === 0;
      })
      .required('Required'),

    ipAddressOrRangeNotation: ipAddrValidation,
  });

  const handleHide = () => {
    onHide();
  };

  return { yupSchema, handleHide };
};
